import request from '@/utils/request'

export function findProfileSuppliers(params) {
  return request({
    url: `/profile_suppliers`,
    method: 'get',
    params
  })
}

export function findProfileSupplier(id) {
  return request({
    url: `/profile_suppliers/${id}`,
    method: 'get'
  })
}

export function findProfileSupplierName(id) {
  return request({
    url: `/profile_suppliers/${id}/name`,
    method: 'get'
  })
}

export function findProfileSupplierForm(id) {
  return request({
    url: `/profile_suppliers/${id}/form`,
    method: 'get'
  })
}

export function findProfileSupplierProfiles(id, params) {
  return request({
    url: `/profile_suppliers/${id}/profiles`,
    method: 'get',
    params
  })
}

export function createProfileSupplier(data) {
  return request({
    url: `/profile_suppliers`,
    method: 'post',
    data
  })
}

export function updateProfileSupplier(id, data) {
  return request({
    url: `/profile_suppliers/${id}`,
    method: 'put',
    data
  })
}
